import { makeSpaceStreamId } from '@towns-protocol/sdk'
import {
    BlockchainTransactionType,
    TransactionContext,
    TSigner,
    useBaseWrites,
    useTransaction,
} from 'use-towns-client'
import { Address } from 'viem'

export type TreasuryTransferWithCurrencyData = {
    contractAddress?: Address
    spaceId: string
    recipient: Address
    currencyAddress: Address
}

export function useTransferTreasury({
    onSuccess,
    onError,
}: {
    onSuccess?: (
        args: TreasuryTransferWithCurrencyData,
        context: TransactionContext<TreasuryTransferWithCurrencyData>,
    ) => void
    onError?: (error: Error) => void
} = {}) {
    const { baseTransactor } = useBaseWrites()

    return useTransaction({
        debugName: 'useTransferTreasury',
        onSuccess: (args, context) => {
            onSuccess?.(args.data, context)
        },
        onError: (error) => {
            onError?.(error)
        },
        execute: async ({
            data,
            signer,
        }: {
            data: TreasuryTransferWithCurrencyData
            signer: TSigner
        }) =>
            baseTransactor.createTransaction({
                signer,
                type: BlockchainTransactionType.WithdrawTreasury,
                debugName: 'withdrawTreasury',
                contextData: data,
                aaExecute: async () => {
                    const transaction = await baseTransactor.userOps?.sendWithdrawSpaceFundsOp({
                        signer,
                        spaceId: data.spaceId,
                        recipient: data.recipient,
                        currencyAddress: data.currencyAddress,
                    })
                    if (!transaction) {
                        throw new Error('Transaction not created')
                    }
                    return transaction
                },
                eoaExecute: () => {
                    throw new Error('Not implemented')
                },
                errorDecoder: (error) => {
                    const spaceId = makeSpaceStreamId(data.spaceId)
                    return baseTransactor.getDecodedErrorForSpace(spaceId, error)
                },
            }),
    })
}
